export interface ShipmentDetailNavState {
  readonly fromPath: string;
  readonly siblingShipmentIds: readonly string[];
}

export const DEFAULT_SHIPMENT_DETAIL_FROM_PATH = '/receive';

export function buildShipmentDetailNavState(
  shipments: readonly { id: string }[],
): ShipmentDetailNavState {
  return {
    fromPath: DEFAULT_SHIPMENT_DETAIL_FROM_PATH,
    siblingShipmentIds: ['all', ...shipments.map((shipment) => shipment.id)],
  };
}

export function parseShipmentDetailNavState(state: unknown): ShipmentDetailNavState {
  if (!state || typeof state !== 'object') {
    return { fromPath: DEFAULT_SHIPMENT_DETAIL_FROM_PATH, siblingShipmentIds: [] };
  }
  const fromPathValue = 'fromPath' in state ? state.fromPath : undefined;
  const siblingValue = 'siblingShipmentIds' in state ? state.siblingShipmentIds : undefined;
  const fromPath =
    typeof fromPathValue === 'string' && fromPathValue.startsWith('/')
      ? fromPathValue
      : DEFAULT_SHIPMENT_DETAIL_FROM_PATH;
  const siblingShipmentIds = Array.isArray(siblingValue)
    ? siblingValue.filter((id: unknown): id is string => typeof id === 'string')
    : [];
  return { fromPath, siblingShipmentIds };
}
